import { translations } from "i18n";
import React, { useEffect, useState } from "react";

import styles from "./style.module.scss";
import Button from "components/Button";
import InfoIcon from "components/InfoIcon";
import InstructionItem from "./components/InstructionItem";
import DeviceItem from "./components/DeviceItem";
import iconToy from "images/icons/no-toys/compatible.svg";
import iconConnect from "images/icons/no-toys/connect-toy.svg";
import iconTurnedOn from "images/icons/no-toys/on.svg";
import iconCharged from "images/icons/no-toys/battery.svg";
import iconBluetooth from "images/icons/no-toys/bluetooth.svg";
import { useConnectedDevices } from "hooks/ConnectedDevicesHook";
import ConnectionFailed from "./components/ConnectionFailed";
import { useDeviceBattery } from "hooks/DeviceBatteryHook";
import { useUserSettings } from "hooks/UserSettingsHook";
import { getContainerWidth } from "utils/utils";
import DisconnectedDevicesModal from "components/DisconnectedDevicesModal";

const ToysPage = () => {
  const { discoverDevices, devices, getConnectionState } =
    useConnectedDevices();
  const { batteryPerDevice } = useDeviceBattery();
  const { showTips } = useUserSettings();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    window.setShowModal = setShowModal;
  }, []);

  const deviceItems = devices.map((device, index) => {
    return (
      <DeviceItem
        device={device}
        key={device.id}
        index={index}
        connectionState={getConnectionState(device)}
        batteryPercent={
          batteryPerDevice?.find((dev) => dev.deviceId === device.id)?.battery
        }
      />
    );
  });

  return (
    <div
      className={styles.settingsContainer}
      style={{ width: getContainerWidth(showTips) }}
    >
      <ConnectionFailed />
      <div className={styles.headerContainer}>
        <div>
          <div className={styles.H1Container}>
            <h1>
              {devices.length
                ? translations("ToysPage.ConnectedToys")
                : translations("ToysPage.BeforeConnecting")}
            </h1>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            classnames={[styles.button]}
            onClick={() => {
              discoverDevices();
            }}
            text={translations("ToysPage.ConnectNewToy")}
            icon={iconConnect}
          />
        </div>
      </div>

      {!devices.length ? (
        <div className={styles.instructionsContainer}>
          <div className={styles.instructionsItems}>
            <InstructionItem
              icon={iconToy}
              title={translations("ToysPage.CompatibleToy")}
              titleIcon={
                <InfoIcon
                  tooltip={`<br>${translations(
                    "ToysPage.SupportedDevices"
                  )}: <br><br>
                  <ul>
                    <li style='color: #fff; font-size: 13px'><b>Kiiroo:</b> Cliona, Pearl2, Pearl2+, Pearl3, Keon, Keon FM, Keon R1, Keon R2, Spot R1, Spot W1, Spot W2, ProWand </li>
                    <li style='color: #fff; font-size: 13px'><b>OhMiBod:</b> Esca2, Fuse, Lumen.</li>
                    <li style='color: #fff; font-size: 13px'><b>Hot Octopuss:</b> Pulse Solo Interactive.</li>
                  </ul><br>`}
                  className={styles.tooltip}
                />
              }
              text={translations("ToysPage.YourInteractiveSexToy")}
            />
            <InstructionItem
              icon={iconCharged}
              title={translations("ToysPage.FullyCharged")}
              text={translations("ToysPage.ToyIsFullyCharged")}
            />
            <InstructionItem
              icon={iconTurnedOn}
              title={translations("ToysPage.SexToyOn")}
              text={translations("ToysPage.YourInteractiveSexToyIsOn")}
            />
            <InstructionItem
              icon={iconBluetooth}
              title={translations("ToysPage.CheckBluetooth")}
              text={translations("ToysPage.YourToyIsInBluetoothMode")}
            />
          </div>
        </div>
      ) : (
        <div className={styles.devicesContainer}>{deviceItems}</div>
      )}
      {showModal && <DisconnectedDevicesModal setShowModal={setShowModal} />}
    </div>
  );
};

export default ToysPage;
